import { formatBps } from '../../domain/equityEngine';
import type { EquitySummary } from '../../domain/types';

interface SummaryPanelProps {
  summary: EquitySummary;
}

const METRICS: Array<{ key: keyof EquitySummary; label: string; tone: string }> = [
  { key: 'potentialBps', label: '最高孵化权益', tone: 'neutral' },
  { key: 'milestoneEarnedBps', label: '里程碑成熟', tone: 'earned' },
  { key: 'timeVestedBps', label: '时间归属', tone: 'vesting' },
  { key: 'exercisableBps', label: '当前可行权', tone: 'success' },
  { key: 'exercisedBps', label: '已行权/已取得', tone: 'success' },
  { key: 'lapsedBps', label: '已失效', tone: 'danger' },
  { key: 'repurchaseAt80RiskBps', label: '80%回购风险', tone: 'warning' },
  { key: 'repurchaseAtNominalRiskBps', label: '成本价/名义价风险', tone: 'danger' },
];

export function SummaryPanel({ summary }: SummaryPanelProps) {
  return (
    <aside className="summary-panel" aria-label="孵化权益汇总">
      <div className="panel-heading">
        <span className="eyebrow">实时汇总</span>
        <h2>孵化权益状态</h2>
      </div>
      <div className="summary-grid">
        {METRICS.map((metric) => (
          <div className={`summary-metric tone-${metric.tone}`} key={metric.key}>
            <span>{metric.label}</span>
            <strong>{formatBps(summary[metric.key])}</strong>
          </div>
        ))}
      </div>
      {summary.blockedBps > 0 ? (
        <div className="blocked-callout">
          <strong>前置限制未清理：</strong>
          {formatBps(summary.blockedBps)} 暂不得主张，需先完成第3.3条利益冲突及限制清理。
        </div>
      ) : null}
    </aside>
  );
}
